export enum LocalStorageEnum {
  OM_culture = 'OM_culture',
  OM_userSessionToken = 'OM_userSessionToken',
  OM_bearerToken = 'OM_bearerToken',
  OM_refreshToken = 'OM_refreshToken',
  OM_tokenExpiry = 'OM_tokenExpiry',
  OM_userSessionURL = 'OM_userSessionURL',
  OM_authVerifierParams = 'OM_authVerifierParams',
  OM_flightResultListUrl = 'OM_flightResultListUrl',
  OM_selectedflightUrl = 'OM_selectedflightUrl',
  OM_changedFlightUrl = 'OM_changedFlightUrl',
  OM_filterOptionsUrl = 'OM_filterOptionsUrl',
  OM_changedFlightPayload = 'OM_changedFlightPayload',
  OM_retrievedFlightIdentifier = 'OM_retrievedFlightIdentifier',
  OM_orderId = 'OM_orderId',
  OM_selectedAffiliate = 'OM_selectedAffiliate',
  Extras_Info = 'Extras_Info',
  OM_FlightIdentifier = 'OM_flightId',
  OM_OrderIdentifier = 'OM_ordertId',
  OM_OrderNumber = 'OM_orderNumber',
  OM_orderReference = 'OM_orderReference',
}

export type LocalStorageEnumType = keyof typeof LocalStorageEnum;
